import styled from "styled-components";
import { ButtonContainer } from "../../components/Button/styles";

export const CreateExpenseContainerIcons = styled.div`
    display: flex;
    margin-bottom: 40px;

    ${ButtonContainer} {
        margin-right: 10px;
        margin-bottom: 10px;
    }
`;

export const CreateExpenseButtonContainer = styled.div`
    display: flex;
`;
